// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7DdpL","label":"styles_label__JwtKY"};